import { getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import useDebounce from "hooks/useDebounce";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Input, Button } from "styled";
import { TD, TH } from "styled/table";
import { FaEdit, FaEye, FaTrash, FaMoon, FaSun } from "react-icons/fa";
import Edit from "../components/stencils/EditStencil";
import Delete from "../components/stencils/DeleteStencil";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import { convertToIndianTimezoneAndGetDate } from "utils/helpers";
import { useDarkMode } from "hooks/useDarkMode";

const AllStencils = () => {
  const [search, setSearch] = useState("");
  const currentUser = useSelector((state) => state.user.currentUser);
  const [originalNSD, setOriginalNSD] = useState("");
  const [retreadNSD, setRetreadNSD] = useState("")
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const[loadingValue,setLoadingValue]=useState(false);
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  const debouncedValue = useDebounce(search, 1000);

  const { data: stencils, isLoading,isFetching } = useQuery(
    ["stencils", debouncedValue && debouncedValue],
    () =>
      getAllData("/stencils", {
        searchQuery: debouncedValue,
        dontFetchInspections: false,
      }),
      {enabled: search.length >= 3} 
  );

  useEffect(()=>{
    if(stencils?.data?.tyre){
      setOriginalNSD(stencils.data.tyre?.tyreType!== "ITM" ? (stencils.data.tyre?.retreadNSD ?? "N/A") : stencils.data.tyre.product?.originalNSD
        ? parseFloat(
            stencils.data.tyre.product.originalNSD
          ).toFixed(2)
        : stencils.data.tyre.productMaster?.originalNSD
        ?  parseFloat(
          stencils.data.tyre.productMaster.originalNSD
        ).toFixed(2)
        :"N/A")

      setRetreadNSD(stencils.data.tyre?.retreadNSD ?? "N/A")
    }
  }, [stencils])

  const getLocation = (status) => {
    switch (status) {
      case "REUSE":
        return "RSU";
      case "RETREAD":
        return "RTD";
      case "CASING":
        return "CS1";
      case "REPAIR":
        return "CTR";
      case "MISSING":
        return "MIS";
      case "SCRAP":
        return "SRP";
      case "READY_TO_FIT_OUT":
        return "ITM";
      case "FITTED":
        return "OWH";
      default:
        return "---";
    }
  };


  const getDate = (inspections, vehicle) => {
    let date = "";
    // console.log(vehicle, "---", inspections);
    // inspections.map((inspection) => {
    //   // console.log(inspection)
    //   if (inspection.vehicle === vehicle) date = inspection.date;
    // });
    return inspections[inspections.length - 1].date;
  };

  console.log('loadingValue--',loadingValue);
  
  return (
    <div>
      <div className="mx-10 my-2">
        <div className="mt-8 flex justify-between items-center gap-6 flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
          <button
            onClick={toggleDarkMode}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors duration-200 ${
              isDarkMode 
                ? 'bg-gray-700 text-yellow-400 hover:bg-gray-600' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
            title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {isDarkMode ? <FaSun /> : <FaMoon />}
            <span className="hidden sm:inline">
              {isDarkMode ? 'Light' : 'Dark'}
            </span>
          </button>
        </div>
      </div>
      {loadingValue || isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              {stencils && stencils.data && stencils.data.tyre ? (
                <div className="stencil-history">
                  <ul>
                    <li>
                      <h3>Enroll Customer:</h3>
                      <span>
                      {stencils.data.inspections.length > 0
                        ? `${stencils.data.inspections[stencils.data.inspections.length - 1].fleet}${stencils.data.inspections[stencils.data.inspections.length - 1].fleetCity ? ` (${stencils.data.inspections[stencils.data.inspections.length - 1].fleetCity})` : ""}`
                        : `${stencils.data.tyre.fleet?.fleetName}${stencils.data.tyre.fleet?.city ? ` (${stencils.data.tyre.fleet.city})` : ""}`}
                    </span>

                    </li>
                    <li>
                      <h3>KM Covered:</h3>
                      <span>
                        {stencils.data.tyre?.killometerTravelled !== undefined && stencils.data.tyre?.killometerTravelled !== null
                          ? stencils.data.tyre.totalKillometerTravelled
                          : stencils.data.inspections.length > 0
                          ? stencils.data.inspections[0]
                              .totalKillometerTravelled
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <h3>Current Customer:</h3>
                      <span>
                      {stencils.data.tyre.fleet?.fleetName
                        ? `${stencils.data.tyre.fleet.fleetName}${stencils.data.tyre.fleet.city ? ` (${stencils.data.tyre.fleet.city})` : ""}`
                        : "N/A"}
                    </span>

                    </li>
                    <li>
                      <h3>Enroll Hub:</h3>
                      <span>
                        {stencils.data.inspections.length > 0
                          ? stencils.data.inspections[
                              stencils.data.inspections.length - 1
                            ].hub
                          : stencils.data.tyre.hub?.hubName}
                      </span>
                    </li>
                    <li>
                      <h3>Original NSD:</h3>
                      <span>{originalNSD}</span>
                    </li>
                    <li>
                      <h3>Current Hub:</h3>
                      <span>{stencils.data.tyre.hub?.hubName}</span>
                    </li>
                    <li>
                      <h3>Enrolled Tyre Type:</h3>
                      <span>
                        {/* // temporary solution for itm rtd1 if tyre type is not available */}
                        {stencils?.data?.tyre?.enrolledTyreType ?? stencils.data.inspections.length > 0
                          ? stencils.data.inspections[
                              stencils.data.inspections.length - 1
                            ]?.tyreType
                            ? stencils.data.inspections[
                                stencils.data.inspections.length - 1
                              ]?.tyreType
                            : "ITM"
                          : stencils.data.tyre.tyreType
                          ? stencils.data.tyre.tyreType
                          : "ITM"}
                      </span>
                    </li>
                    <li>
                      <h3>G1 NSD:</h3>
                      <span>{stencils.data.tyre.G1 ? stencils.data.tyre.G1 : originalNSD}</span>
                    </li>
                    <li>
                      <h3>Current Tyre Type:</h3>
                      <span>
                        {stencils.data.tyre.tyreType
                          ? stencils.data.tyre.tyreType
                          : stencils.data.tyre.enrolledTyreType
                          ? stencils.data.tyre.enrolledTyreType
                          : "ITM"}
                      </span>
                      {stencils.data.tyre.soldOut && (
                        <span className="text-red-500"> Sold*</span>
                      )}
                    </li>
                    <li>
                      <h3>Enrolled Tyre Loc:</h3>
                      <span>
                        {stencils.data.tyre.enrolledStatus
                          ? getLocation(stencils.data.tyre.enrolledStatus)
                          : "ITM"}
                      </span>
                    </li>
                    <li>
                      <h3>G2 NSD:</h3>
                      <span>{stencils.data.tyre.G2 ? stencils.data.tyre.G2 : originalNSD}</span>
                    </li>
                    <li>
                      <h3>Current Tyre Loc:</h3>
                      <span>{stencils.data.tyre.tyreLocation}</span>
                    </li>
                    <li>
                      <h3>Owner desc:</h3>
                      <span>
                        {stencils.data.tyre.owner
                          ? stencils.data.tyre.owner
                          : stencils.data.tyre.isGrnTyre
                          ? "JK"
                          : "FLEET"}
                      </span>
                    </li>
                    <li>
                      <h3>G3 NSD:</h3>
                      <span>{stencils.data.tyre.G3 ? stencils.data.tyre.G3 : originalNSD}</span>
                    </li>
                    <li>
                      <h3>Tyre Position:</h3>
                      <span>
                        {/* {stencils.data.tyre.status === "FITTED"
                          ? stencils.data.inspections.length > 0
                            ? stencils.data.inspections[0].tyrePosition
                            : stencils.data.tyre.position
                          : "N/A"} */}
                        {stencils.data.tyre?.position
                          ? stencils.data.tyre.position !== ""
                            ? stencils.data.tyre.position
                            : "N/A"
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <h3>Tyre Company:</h3>
                      <span>
                        {stencils.data.tyre.product
                          ? "JK Tyre"
                          : stencils.data.tyre.productMaster?.companyName}
                      </span>
                    </li>
                    <li>
                      <h3>G4 NSD:</h3>
                      <span>{stencils.data.tyre.G4 || "N/A"} </span>
                    </li>
                    <li>
                      <h3>Last Insp. date:</h3>
                      <span>
                        {stencils.data.inspections.length > 0 &&
                          stencils.data.inspections[0].date}
                      </span>
                    </li>
                    <li>
                      <h3>Material Desc:</h3>
                      <span>
                        <TD>
                          {stencils.data.tyre.product
                            ? stencils.data.tyre.product?.productName
                            : stencils.data.tyre.productMaster?.productName}
                        </TD>
                      </span>
                    </li>
                    <li>
                      <h3>Ip Condition:</h3>
                      <span>{stencils.data.tyre.temperature}</span>
                    </li>
                    <li>
                      <h3>Fitment Date:</h3>
                      <span>
                        {/* {stencils.data.tyre.product &&
                          stencils.data.inspections.length > 0 &&
                          stencils.data.inspections[0].date} */}
                        {stencils.data.inspections.length > 0
                          ? getDate(
                              stencils.data.inspections,
                              stencils.data.tyre.vehicle
                            )
                          : stencils.data.tyre.fitmentDate
                          ? stencils.data.tyre.fitmentDate
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <h3>Size desc.:</h3>
                      <span>
                        {stencils.data.tyre.product?.tyreSize ||
                          stencils.data.tyre.productMaster?.tyreSize ||
                          "---"}
                      </span>
                    </li>
                    <li>
                      <h3>IP PSI:</h3>
                      <span>{stencils.data.tyre.pressure}</span>
                    </li>
                    <li>
                      <h3>Vehicle No:</h3>
                      <span>
                        {stencils.data.tyre.status === "FITTED"
                          ? stencils.data.tyre.vehicle
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <h3>Challan No:</h3>
                      <span>
                        {stencils.data.tyre.chalanDetails?.Challan_No
                          ? stencils.data.tyre.chalanDetails.Challan_No
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <h3>Accepted By:</h3>
                      <span>
                        {stencils.data.tyre.chalanDetails?.acceptedBy
                          ? stencils.data.tyre.chalanDetails.acceptedBy
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <h3>Accepted On:</h3>
                      <span>
                        {stencils.data.tyre.chalanDetails?.acceptedAt
                          ? convertToIndianTimezoneAndGetDate(
                              stencils.data.tyre.chalanDetails.acceptedAt
                            )
                          : "N/A"}
                      </span>
                    </li>
                    <li>
                      <h3>Validated Date:</h3>
                      <span>{stencils.data.tyre.validatedDate || "N/A"}</span>
                    </li>
                    <li>
                      <h3>Validated By:</h3>
                      <span>{stencils.data.tyre.validatedBy || "N/A"}</span>
                    </li>
                    <li>
                      <h3>Sold Date:</h3>
                      <span>{stencils.data.tyre.soldDate || "N/A"}</span>
                    </li>
                    <li></li>
                    <li></li>
                    <li>

                        <div className="justify-end">
                          {checkPermission(
                            [
                              permissions.manage_stencil_search,
                              permissions.manage_stencil_menu,
                            ],
                            currentUser
                          ) && <button
                            onClick={() => setShowEditModel(true)}
                            className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
                          >
                              <FaEdit />
                            </button>}
                          {checkPermission(
                            [
                              permissions.delete_tyre,
                            ],
                            currentUser
                          ) && stencils.data.tyre.status !== "FITTED" && (
                              <button
                                onClick={() => setShowDeleteModel(true)}
                                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
                              >
                                <FaTrash />
                              </button>
                            )}
                        </div>
                        
                    </li>
                  </ul>
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <TH scope="col">S.N.</TH>
                          <TH scope="col">Inspection Date</TH>
                          <TH scope="col">Inspection Number</TH>
                          <TH scope="col">Vehicle</TH>
                          <TH scope="col">Tyre Position</TH>
                          <TH scope="col">Contract</TH>
                          <TH scope="col">Hub</TH>
                          <TH scope="col">Tyre Location</TH>
                          <TH scope="col">Tyre Type</TH>
                          <TH scope="col">NSD G1</TH>
                          <TH scope="col">NSD G2</TH>
                          <TH scope="col">NSD G3</TH>
                          <TH scope="col">NSD G4</TH>
                          <TH scope="col">Average NSD</TH>
                          <TH scope="col">Total KM Travelled</TH>
                          <TH scope="col">Milo Meter Reading</TH>
                          <TH scope="col">KM Covered</TH>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {stencils.data.inspections &&
                          stencils.data.inspections.length > 0 &&
                          stencils.data.inspections.map((inspection, index) => (
                            <tr
                              key={stencils.data._id}
                              className={`${index % 2 !== 0 && "bg-gray-100"}`}
                            >
                              <TD>{index + 1}</TD>
                              <TD>{inspection.date}</TD>
                              <TD>{inspection.inspectionNumber}</TD>
                              <TD>{inspection.vehicle}</TD>
                              <TD>{inspection.tyrePosition}</TD>
                              <TD>{inspection.contractType}</TD>
                              <TD>{inspection.hub}</TD>
                              <TD>{inspection.tyreLocation}</TD>
                              {/* <TD>{getLocation(inspection.status)}</TD> */}
                              <TD>{inspection.tyreType ?? "ITM"}</TD>
                              <TD>{inspection.G1}</TD>
                              <TD>{inspection.G2}</TD>
                              <TD>{inspection.G3}</TD>
                              <TD>{inspection.G4}</TD>
                              <TD>
                                {parseFloat(inspection.averageNSD).toFixed(2)}
                              </TD>
                              <TD>{inspection.killometerTravelled}</TD>
                              <TD>
                                {inspection.odometerReading !== undefined
                                  ? inspection.odometerReading
                                  : inspection.milometerReading}
                              </TD>
                              <TD>{inspection.totalKillometerTravelled}</TD>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="text-center justify-center">
                  {" "}
                  No Stencil Found{" "}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showEditModel && (
        <Edit
          key={stencils.data.tyre.stencilNo + "1"}
          originalNSD={originalNSD}
          retreadNSD={retreadNSD}
          currentUser={currentUser}
          data={stencils.data.tyre}
          inspectionId={
            stencils.data.inspections.length && stencils.data.inspections[0]._id
          }
          inspectionDetail={
            stencils.data.inspections.length > 1 && stencils.data.inspections[1]
          }
          handleClick={() => setShowEditModel(false)}
          debouncedValue={debouncedValue}
          isFetching={isFetching}
          setLoadingValue={setLoadingValue}
        />
      )}
      {showDeleteModel && (
        <Delete
          data={stencils.data.tyre}
          handleClick={() => setShowDeleteModel(false)}
        />
      )}
    </div>
  );
};

export default AllStencils;

// rtd-rsu,nsd same as inspectios    